import React from 'react';
import { usaProductos, usaServicios } from '../utils/queVende';
import InstalarApp from './InstalarApp';

// Panel lateral de Kontrol (by Automatika.IA). Reemplaza la barra superior.
// La esencia Automatika (degradado, logo, estructura) es fija; el color de
// acento sale de --color-primario y el tema (morado/lavanda) de [data-panel].

const ICONOS = {
  home: 'M3 10.5 12 3l9 7.5 M5 9.5V20h14V9.5',
  cart: 'M2 3h3l2.2 12.2a1.6 1.6 0 0 0 1.6 1.3h8.2a1.6 1.6 0 0 0 1.6-1.3L21 7H6',
  box: 'M21 8 12 3 3 8v8l9 5 9-5Z M3 8l9 5 9-5 M12 13v8',
  bag: 'M6 8h12l-1 12H7L6 8Z M9 8V6a3 3 0 0 1 6 0v2',
  tools: 'M4 20h16 M6 20V9l4-3 4 3v11 M14 20V12l4-2v10',
  quote: 'M7 3h7l4 4v14H7Z M14 3v4h4 M9.5 12h5 M9.5 15.5h5',
  clock: 'M12 7v5l3 2',
  clipboard: 'M9 4h6v2H9Z M7 5h10v15H7Z M9.5 11h5 M9.5 14.5h5',
  tag: 'M4 12V5a1 1 0 0 1 1-1h7l8 8-8 8-8-8Z',
  wallet: 'M3 6h15a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3Z M3 10h18',
  bank: 'M4 10 12 4l8 6 M6 10v8M10 10v8M14 10v8M18 10v8 M4 20h16',
  receipt: 'M6 3h12v18l-3-2-3 2-3-2-3 2V3Z M9 8h6M9 12h6',
  coins: 'M14.5 5.3A5 5 0 1 1 15 18.6',
  cal: 'M3 5h18v16H3Z M3 10h18M8 3v4M16 3v4',
  sun: 'M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5 19 19M19 5l-1.5 1.5M6.5 17.5 5 19',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  users: 'M3 20a6 6 0 0 1 12 0 M16 5.2A3.2 3.2 0 0 1 16 11M21 20a6 6 0 0 0-4-5.6',
  gear: 'M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1',
  plus: 'M12 5v14M5 12h14',
  exit: 'M15 12H4 M11 8l-4 4 4 4 M15 4h4v16h-4',
  gem: 'M6 3h12l4 6-10 12L2 9Z M2 9h20 M12 21 8 9l4-6 4 6-4 12',
  shield: 'M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6Z',
  mega: 'M3 10v4h3l6 4V6L6 10H3Z M16 9a3.5 3.5 0 0 1 0 6 M19 6a7.5 7.5 0 0 1 0 12',
  spark: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8Z M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8Z',
  target: 'M12 12l7-7 M16 5h3v3',
  help: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18Z M9.6 9.3a2.5 2.5 0 1 1 3.4 2.3c-.6.3-1 .8-1 1.5v.6 M12 17v.4',
};

function Ic({ n }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {n === 'coins' && <circle cx="9" cy="9" r="5" />}
      {n === 'users' && <circle cx="9" cy="8" r="3.2" />}
      {n === 'cart' && (<><circle cx="9" cy="20" r="1.3" /><circle cx="18" cy="20" r="1.3" /></>)}
      {n === 'gear' && <circle cx="12" cy="12" r="3" />}
      {n === 'sun' && <circle cx="12" cy="12" r="4" />}
      {n === 'clock' && <circle cx="12" cy="12" r="9" />}
      {n === 'target' && (<><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1.2" /></>)}
      <path d={ICONOS[n]} />
    </svg>
  );
}

export default function Sidebar({
  negocio, vistaActual, totalProductos, stockBajo, pedidosPendientes = 0,
  onIrInicio, onVender, onNuevoProducto, onIrInventario, onVerServicios, onVerCotizaciones, onVerAgenda, onVerOrdenes, onVerPedidos, onCompartir,
  onVerBalance, onVerCuentas, onVerGastos, onVerPorCobrar, onVerCierre, onVerCorte, onVerFacturas,
  onVerReportes, onVerClientes, onVerConfiguracion, onVerStockBajo, onCerrarSesion,
  onVerPlanes, onVerAdmin, onVerEquipo, onVerVentasHoy, onVerCuenta, onVerAnuncios, onVerContenido, onVerMetas, onVerAyuda, esVendedora = false, puede = () => true,
}) {
  // La dueña ve todo; su equipo, según los permisos que ella le dio.
  const g = !esVendedora;
  const p = puede;
  const dinero = ['balance', 'cuentas', 'gastos', 'por_cobrar', 'corte', 'cierre'].some((k) => p(k));
  const item = (icon, label, activo, onClick, badge) => (
    <button className={`k-item${activo ? ' on' : ''}`} onClick={onClick}>
      <Ic n={icon} />{label}
      {badge != null && <span className="k-badge">{badge}</span>}
    </button>
  );
  // "¿Qué vendes?" (sql/144): solo se ocultan partes del menú; no se borra nada.
  const conProductos = usaProductos(negocio?.vende);
  const conServicios = usaServicios(negocio?.vende);
  const inv = vistaActual === 'inventario' || vistaActual === 'categorias' || vistaActual === 'grupos' || vistaActual === 'detalle';
  const inicial = (negocio?.nombre || 'K').trim().charAt(0).toUpperCase();

  return (
    <aside className="k-sb">
      <div className="k-brand">
        <span className="k-klogo">
          <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M8 4v16" /><path d="M8 12 17 4" /><path d="M8 12l9 8" />
          </svg>
        </span>
        <div><h1>Kontrol</h1><div className="k-by">by Automatika.IA</div></div>
      </div>

      <div className="k-biz">
        <span className="k-dot">{negocio?.logo_url ? <img src={negocio.logo_url} alt="" /> : '🛍️'}</span>
        <div style={{ minWidth: 0 }}>
          <b>{negocio?.nombre || 'Mi Negocio'}</b>
          <span>{negocio?.rol === 'duena' ? 'Dueña' : negocio?.rol === 'vendedora' ? 'Vendedor/a' : (negocio?.rol || 'Negocio')}</span>
        </div>
      </div>

      <div className="k-cta">
        {conProductos
          ? <button className="k-vender" onClick={onVender}><Ic n="cart" />Vender</button>
          : <button className="k-vender" onClick={onVerCotizaciones}><Ic n="quote" />Cotizar</button>}
        {conProductos && p('productos') && <button className="k-nuevo" onClick={onNuevoProducto}><Ic n="plus" />Producto</button>}
        {!conProductos && <button className="k-nuevo" onClick={onVerServicios}><Ic n="tools" />Servicios</button>}
      </div>

      <nav className="k-nav">
        <div className="k-grp">Inicio</div>
        {item('home', 'Inicio', vistaActual === 'inicio', onIrInicio)}
        {item('cart', 'Ventas de hoy', vistaActual === 'ventashoy', onVerVentasHoy)}
        {!esVendedora && onVerMetas && item('target', 'Mis metas', vistaActual === 'metas', onVerMetas)}

        {conProductos && <>
          <div className="k-grp">Productos</div>
          {item('box', 'Inventario', inv, onIrInventario, totalProductos)}
          {item('bag', 'Pedidos de productos', vistaActual === 'pedidos', onVerPedidos, pedidosPendientes > 0 ? pedidosPendientes : null)}
          {item('tag', 'Catálogo de productos', false, onCompartir)}
        </>}

        {conServicios && <>
          <div className="k-grp">Servicios</div>
          {item('tools', 'Servicios', vistaActual === 'servicios', onVerServicios)}
          {item('quote', 'Cotizaciones', vistaActual === 'cotizaciones', onVerCotizaciones)}
          {item('clock', 'Agenda', vistaActual === 'agenda', onVerAgenda)}
          {item('clipboard', 'Órdenes de servicio', vistaActual === 'ordenes', onVerOrdenes)}
        </>}

        {dinero && <div className="k-grp">Dinero</div>}
        {p('balance') && item('wallet', 'Balance', vistaActual === 'balance', onVerBalance)}
        {p('cuentas') && item('bank', 'Cuentas', vistaActual === 'cuentas', onVerCuentas)}
        {p('gastos') && item('receipt', 'Gastos', vistaActual === 'gastos', onVerGastos)}
        {p('por_cobrar') && item('coins', 'Por cobrar', vistaActual === 'porcobrar', onVerPorCobrar)}
        {p('corte') && item('sun', 'Corte del día', vistaActual === 'corte', onVerCorte)}
        {p('cierre') && item('cal', 'Cierre de mes', vistaActual === 'cierre', onVerCierre)}
        {g && onVerFacturas && item('receipt', 'Facturas', vistaActual === 'facturas', onVerFacturas)}

        <div className="k-grp">{p('reportes') ? 'Análisis' : 'Clientes'}</div>
        {p('reportes') && item('chart', 'Reportes', vistaActual === 'reportes', onVerReportes)}
        {onVerAnuncios && item('mega', 'Anuncios de Meta', vistaActual === 'anuncios', onVerAnuncios)}
        {onVerContenido && item('spark', 'Contenido', vistaActual === 'contenido', onVerContenido)}
        {item('users', 'Clientes', vistaActual === 'clientes', onVerClientes)}

        {g && <>
        <div className="k-grp">Cuenta</div>
        {item('gem', 'Mi plan', vistaActual === 'planes', onVerPlanes)}
        {item('users', 'Mi equipo', vistaActual === 'equipo', onVerEquipo)}
        </>}
        {!g && <div className="k-grp">Cuenta</div>}
        {item('users', 'Mi cuenta', vistaActual === 'cuenta', onVerCuenta)}
        {onVerAyuda && item('help', 'Herramientas y Ayuda', vistaActual === 'ayuda', onVerAyuda)}
        {onVerAdmin && item('shield', 'Admin Kontrol', vistaActual === 'admin', onVerAdmin)}
        <InstalarApp />

        {p('productos') && stockBajo > 0 && (
          <button className="k-alert" onClick={onVerStockBajo}>⚠️ {stockBajo} con stock bajo</button>
        )}
      </nav>

      <div className="k-foot">
        <span className="k-av">{inicial}</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <b>{negocio?.nombre || 'Mi Negocio'}</b>
          <span>Kontrol · Automatika.IA</span>
        </div>
        {g && <button className={`k-ico${vistaActual === 'config' ? ' on' : ''}`} title="Configuración" onClick={onVerConfiguracion}><Ic n="gear" /><span className="k-ico-txt">Ajustes</span></button>}
        <button className="k-ico" title="Cerrar sesión" onClick={onCerrarSesion}><Ic n="exit" /><span className="k-ico-txt">Salir</span></button>
      </div>
    </aside>
  );
}
